<template lang="html">
  <div class="card-cont-recurso col-sm-6 col-lg-4">
    <div class="card-recurso">
      <router-link :to="$t('enlaces.ficha_recurso')+'/'+data.idRecurso"></router-link>
      <img v-if="!!data.imagen" :src="'data:application/gzip;base64,'+data.imagen"></img>
      <div v-else class="no-image-recurso"></div>
      <div style="height: 11%; width: 100%;">
        <label class="lbl-tipo-recurso">{{data.tipoCategoria.toUpperCase()}}</label>
        <label class="lbl-date-recurso">{{data.fechaPublicacion}}</label>
      </div>
      <label class="lbl-title-recurso">{{data.titulo}}</label>
      <label class="lbl-body-recurso">{{data.entradilla}}</label>
    </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'actualidad-el',
    props :['data'],
    methods : {
      
    },
    filters: {
    }
  }
</script>

<style scoped lang="scss">

.card-cont-recurso{
    height: 350px;
    padding: 15px !important;
    min-width: 250px;
  }

  .card-recurso{
    height: 100%;
    width: 100%;
    margin: 15px;
    background: #F0ECE8;
    cursor: pointer;

    a{
      position: absolute;
      width: calc(100% - 30px);
      height: calc(100% - 30px);
      top: 30px;
      left: 30px;
    }

    img{
      height: 52%;
      width: 100%;
      object-fit: cover;
    }

    .no-image-recurso{
      height: 52%;
      width: 100%;
      background: #cfcdcb;
    }

    .lbl-tipo-recurso{
      float: left;
      text-align: left;
      margin-left: 18px;
      margin-top: 13px;
      width: calc(100% - 140px);
      color: #386DB0;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

    }

    .lbl-date-recurso{
      float: right;
      width: 90px;
      margin-right: 18px;
      margin-top: 13px;
      cursor: pointer;
    }

    .lbl-title-recurso{
      width: 90%;
      height: 44%; //TOCAR ESTE PORCENTAJE PARA DARLE MÁS ESPACIO AL TITULO O A LA ENTRADILLA (EN TOTAL QUE SEA 44%)
      font-weight: 600;
      font-size: 24px;
      text-align: left;
      margin: 10px 18px;
      display:inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    .lbl-body-recurso{
      width: 90%;
      font-size: 18px;
      text-align: left;
      margin: 0 18px;
      height: 0%;  //TOCAR ESTE PORCENTAJE PARA DARLE MÁS ESPACIO AL TITULO O A LA ENTRADILLA (EN TOTAL QUE SEA 44%)
      display:inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/views/orientacion/recurso-el.vue